import React from 'react';
import OfferMiniDetails from './OfferMiniDetails';
import bachelorImg from '../../../images/webp/bachelorette.webp';
import newYearImg from '../../../images/webp/new-year.webp';
import birthdayImg from '../../../images/webp/birthday.webp';
import corporateImg from '../../../images/webp/corporate.png';

const offerMiniData = [
    {
        id: 1,
        img: bachelorImg,
        title: 'Bachelorette parties',
        description: 'Morbi accumsan cras feugiat euismod suspendisse purus. Laoreet mi leo id pretium.',
        tag: 'BacheloretteHash'
    },
    {
        id: 2,
        img: newYearImg,
        title: "New Year's Eve parties",
        description: 'Nec scelerisque tristique sollicitudin purus pulvinar morbi ornare vestibulum.',
        tag: 'newYearHash'
    },
    {
        id: 3,
        img: birthdayImg,
        title: 'Birthday parties',
        description: 'Turpis ad interdum eu imperdiet maecenas potenti volutpat viverra rutrum lectus.',
        tag: 'birthdayHash'
    },
    {
        id: 4,
        img: corporateImg,
        title: 'Corporate events',
        description: 'Fermentum non urna metus ornare diam laoreet nam diam ullamcorper eget malesuada.',
        tag: 'corporateHash'
    }
]

const OfferMini = () => {
    return (
        <div style={{ marginTop: '-200px', textAlign: 'center', color: 'white' }}>
            <h3 data-aos="fade-up" data-aos-duration="1500" className="style-font">Time to party</h3>
            <h1 data-aos="fade-up" data-aos-duration="2500" className="fw-bolder">Maecenas etiam <span style={{ color: '#ff3465' }}>adipiscing</span> magna</h1>
            <div className="row">
                {
                    offerMiniData.map(data => <OfferMiniDetails key={data.id} data={data}></OfferMiniDetails>)
                }
            </div>
        </div>
    );
};

export default OfferMini;